import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { CheckPasswordInterfaceState } from '../../../shared/store/state/check-password.state';
import { AddressInterface } from '../../models/address.interface';
import { CheckPasswordInterface } from '../../../shared/models/check-password.interface';
import { Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { DeleteShippingAddress, EAddressActions } from '../../store/actions/address.actions';
import { AlertMessageInterface } from '../../../shared/models/alert-message.interface';
import { GetAlertMessage } from '../../../shared/store/actions/alert-message.actions';

@Component({
    selector: 'app-delete-shipping-address',
    templateUrl: './delete-shipping-address.component.html',
    styleUrls: ['./delete-shipping-address.component.css'],
    standalone: false
})
export class DeleteShippingAddressComponent implements OnInit {

  address: AddressInterface;
  passwordResponse: CheckPasswordInterface;

  constructor(
      private store: Store<any>,
      private router: Router,
      private action: Actions,
  ) {}

  ngOnInit() {
    this.store.pipe(select(ConstsHelper.REDUCER_CHECK_PASSWORD)).subscribe((response: CheckPasswordInterfaceState) => {
      if (response.result != null && 'delete-shipping-address' === response.result.page) {
        this.passwordResponse = response.result;
        this.address = response.result.object;
      }
    });

    this.action.pipe(ofType(EAddressActions.DeleteShippingAddressSuccess)).subscribe((result: any) => {
      if (result) {
        const alertMessage = ({ message: 'Votre adresse a bien été supprimée.', code: 200 }) as AlertMessageInterface;
        this.store.dispatch(new GetAlertMessage(alertMessage));
        window.location.reload();
      }
    });

    if (!this.passwordResponse || this.passwordResponse.isValid === false) {
      this.cancel();
    }
  }

  cancel() {
    this.router.navigate(['compte/adresses']);
  }

  delete() {
    this.store.dispatch(new DeleteShippingAddress(this.address.id, this.passwordResponse.password));
  }
}
